import React, { useState } from "react";
import DocumentsDisplay from "./documents/DocumentsDisplay";
import AssistantDisplay from "./assistant/AssistantDisplay";

// Knowledge Hub combines the Knowledge Base (file manager) and the Knowledge
// Assistant (AI chat) into a single tab. The Knowledge Base is the primary
// view; the Assistant is reached via a "Chat with Knowledge Base" button next to
// the search bar and offers a "Knowledge Base" button to return. The Assistant
// is kept low-prominence on purpose — the Operations Assistant covers most of
// the same ground.
export default function KnowledgeHubDisplay(props) {
  const documentsEnabled = props.documentsEnabled;
  const assistantEnabled = props.assistantEnabled;

  // Knowledge Base is the default. If a company only has the Assistant
  // enabled, fall back to showing that instead.
  const [activeView, setActiveView] = useState(
    documentsEnabled ? "documents" : "assistant"
  );

  const documents = (
    <DocumentsDisplay
      homeStore={props.homeStore}
      homeCompany={props.homeCompany}
      storeOptions={props.storeOptions}
      storeNames={props.storeNames}
      username={props.username}
      change_home_store={props.change_home_store}
      permissionRole={props.permissionRole}
      permissionOverrides={props.permissionOverrides}
      onOpenAssistant={
        assistantEnabled ? () => setActiveView("assistant") : undefined
      }
    />
  );

  const assistant = (
    <AssistantDisplay
      homeStore={props.homeStore}
      homeCompany={props.homeCompany}
      storeOptions={props.storeOptions}
      storeNames={props.storeNames}
      username={props.username}
      change_home_store={props.change_home_store}
      permissionRole={props.permissionRole}
      company={props.company}
      onBackToKnowledgeBase={
        documentsEnabled ? () => setActiveView("documents") : undefined
      }
    />
  );

  const showView =
    activeView === "assistant" && assistantEnabled ? "assistant" : "documents";

  return (
    <div className="h-screen overflow-auto bg-white">
      {showView === "assistant" ? assistant : documents}
    </div>
  );
}
